import { render } from "./LocationHistory.vue?vue&type=template&id=29090146"
import script from "./LocationHistory.vue?vue&type=script&lang=js"
export * from "./LocationHistory.vue?vue&type=script&lang=js"
script.render = render

export default script